<template>
  <div class="flex flex-col items-baseline md:flex-row md:space-x-8">
    <span class="text-static-default-hi body-1">
      {{ i18n.price(price) }}

      <template v-if="isMonthly">
        {{ i18n(translations.monthlyPayment) }}
      </template>
    </span>

    <span v-if="isMonthly" class="text-static-default-low caption">
      {{ i18n(translations.oneYearEnrollment, { totalPrice }) }}
    </span>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type { Price } from '@backmarket/http-api'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import translations from './InsurancePrice.translations'

const props = defineProps<{
  price: Price
  isMonthly: boolean
}>()

const i18n = useI18n()

const totalPrice = computed(() => {
  return i18n.price({
    amount: (parseFloat(props.price.amount) * 12).toString(),
    currency: props.price.currency,
  })
})
</script>
